import { motion } from "framer-motion";
import { IMG } from "../../data/site";
import { ArrowRight, ArrowDown } from "lucide-react";

const line = {
  hidden: { y: "110%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 0.9, delay: 0.2 + i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

const MaskLine = ({ children, i }) => (
  <span className="block overflow-hidden">
    <motion.span className="block" variants={line} custom={i} initial="hidden" animate="show">
      {children}
    </motion.span>
  </span>
);

export const Hero = ({ onExplore, onEnquire }) => {
  return (
    <section className="relative min-h-[100svh] flex items-end overflow-hidden bg-black">
      {/* parallax background */}
      <motion.div
        className="absolute inset-0"
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
      >
        <img src={IMG.hero} alt="Sasya Hero showroom" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-transparent to-transparent" />
      </motion.div>

      <div className="grain-overlay" />

      <div className="relative z-10 w-full mx-auto max-w-[1400px] px-6 md:px-10 pb-16 md:pb-24 pt-32">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="flex items-center gap-3 mb-6"
        >
          <span className="h-px w-10 bg-red-600" />
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-red-500">Authorised Hero MotoCorp & VIDA Dealer</span>
        </motion.div>

        <h1 className="font-heading font-bold uppercase leading-[0.86] tracking-tighter text-white text-5xl sm:text-7xl lg:text-[8.5vw]">
          <MaskLine i={0}>Ride the</MaskLine>
          <MaskLine i={1}>
            <span className="text-red-600">Sasya</span> legacy
          </MaskLine>
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9, duration: 0.7 }}
          className="mt-7 max-w-xl text-base md:text-lg text-zinc-300 leading-relaxed"
        >
          Trusted two-wheeler dealership since <span className="text-white font-semibold">2002</span>. Explore every Hero
          scooter, motorcycle and VIDA electric — with sales, finance & expert service under one roof.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.05, duration: 0.7 }}
          className="mt-9 flex flex-wrap items-center gap-4"
        >
          <button
            onClick={onExplore}
            data-testid="hero-explore-btn"
            className="group flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white font-bold uppercase tracking-wide px-7 py-4 transition-colors"
          >
            Explore Vehicles
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            onClick={onEnquire}
            data-testid="hero-enquire-btn"
            className="flex items-center gap-3 border border-white/25 hover:border-white text-white font-bold uppercase tracking-wide px-7 py-4 transition-colors"
          >
            Enquire to Buy
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.4 }}
          className="mt-14 flex items-center gap-8 text-zinc-400"
        >
          <div>
            <div className="font-heading text-3xl md:text-4xl font-bold text-white">23<span className="text-red-600">+</span></div>
            <div className="text-xs uppercase tracking-widest">Years of trust</div>
          </div>
          <span className="h-10 w-px bg-white/15" />
          <div>
            <div className="font-heading text-3xl md:text-4xl font-bold text-white">3</div>
            <div className="text-xs uppercase tracking-widest">Showrooms</div>
          </div>
          <span className="h-10 w-px bg-white/15" />
          <div>
            <div className="font-heading text-3xl md:text-4xl font-bold text-white">20<span className="text-red-600">+</span></div>
            <div className="text-xs uppercase tracking-widest">Models on display</div>
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.6 }}
        className="absolute bottom-6 right-6 md:right-10 hidden md:flex items-center gap-2 text-zinc-400 text-xs uppercase tracking-widest"
      >
        Scroll <ArrowDown size={14} className="animate-bounce" />
      </motion.div>
    </section>
  );
};
